export default __webpack_public_path__ + "static/media/ic_digital_service.610c7e20.svg";